// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"45":"wheel","743":"timer","800":"dataset","808":"upgrade","991":"prediction"}[chunkId] + "." + {"45":"4f49e19d","743":"46bff9f2","800":"eeb3ab42","808":"bb07a0a1","991":"6b25bf92"}[chunkId] + ".js";
};